export default {"src":"/_next/static/media/ic-restore.75ac93d6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};